import { render } from "./card.vue?vue&type=template&id=208f7240&scoped=true&bindings={\"cardType\":\"props\",\"cardData\":\"props\",\"hours\":\"options\",\"months\":\"options\",\"style\":\"options\",\"clickVariation\":\"options\",\"clickItem\":\"options\"}"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"

import "./card.vue?vue&type=style&index=0&id=208f7240&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-208f7240"

export default script